<template>
  <div class="deduct_personal">
    <template-form
      title="ค่าลดหย่อนต่างๆ"
      description="กรอกค่าลดหย่อนต่างๆที่คุณใช้สิทธิ์"
    >
      <div class="dpb-detail">
        <h4>ส่วนตัวและครอบครัว</h4>
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">ส่วนตัว</div>
        <currency mode="readOnly" class="left" v-model="personalAllowance" />
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">คู่สมรส</div>
        <dropdown
          :options="spouseOptions"
          v-model="spouse"
          :onChange="setSpouse"
        />
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">
          ค่าคลอดบุตร<span>(สูงสุด ฿60,000/คน)</span>
        </div>
        <currency v-model="pregnancy" v-on:change="setPregnancy" />
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">บุตร <span>(สูงสุด ฿30,000/คน)</span></div>
        <currency v-model="children" v-on:change="setChildren" />
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">พ่อแม่</div>
        <dropdown
          :options="parentsOptions"
          v-model="parents"
          :onChange="setParents"
        />
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">
          ผู้พิการ/ทุพลภาพ
        </div>
        <dropdown
          :options="handicapsOptions"
          v-model="handicaps"
          :onChange="setHandicaps"
        />
      </div>

      <div class="dpb-footer">
        <back-button caption="ก่อนหน้า" />

        <chevron-right-link @clickLink="goNext" caption="ถัดไป" />
      </div>
    </template-form>

    <div class="dp-loading">
      <div class="dpl-active" />
    </div>
    <StateAnswer />
  </div>
</template>

<script>
import StateAnswer from "@/components/StateAnswer.vue";

export default {
  name: "DeductPersonal",
  components: {
    StateAnswer,
  },
  data() {
    const spouse = this.$store.getters["taxInfo/getDeduct"].spouse;
    const pregnancy = this.$store.getters["taxInfo/getDeduct"].pregnancy;
    const children = this.$store.getters["taxInfo/getDeduct"].children;
    const parents = this.$store.getters["taxInfo/getDeduct"].parents;
    const handicaps = this.$store.getters["taxInfo/getDeduct"].handicaps;
    return {
      personalAllowance: 60000,
      spouse,
      pregnancy,
      children,
      parents,
      handicaps,
      spouseOptions: [
        { lable: "ไม่มี", value: 0 },
        { lable: "มี (฿60,000)", value: 60000 },
      ],
      parentsOptions: [
        { lable: "ไม่มี", value: 0 },
        { lable: "1 คน (30,000 บาท)", value: 30000 },
        { lable: "2 คน (60,000 บาท)", value: 60000 },
        { lable: "3 คน (90,000 บาท)", value: 90000 },
        { lable: "4 คน (120,000 บาท)", value: 120000 },
      ],
      handicapsOptions: [
        { lable: "ไม่มี", value: 0 },
        { lable: "1 คน (60,000 บาท)", value: 60000 },
        { lable: "2 คน (120,000 บาท)", value: 120000 },
        { lable: "3 คน (180,000 บาท)", value: 180000 },
        { lable: "4 คน (240,000 บาท)", value: 240000 },
        { lable: "5 คน (300,000 บาท)", value: 300000 },
        { lable: "6 คน (360,000 บาท)", value: 360000 },
        { lable: "7 คน (420,000 บาท)", value: 420000 },
        { lable: "8 คน (480,000 บาท)", value: 480000 },
        { lable: "9 คน (540,000 บาท)", value: 540000 },
        { lable: "10 คน (600,000 บาท)", value: 600000 },
      ],
    };
  },
  methods: {
    goNext() {
      this.$router.push({ path: "/forms/deduct_house" });
    },
    setPersonalAllowance() {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "personalAllowance",
        value: 60000,
      });
    },
    setSpouse(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "spouse",
        value: value,
      });
    },
    setPregnancy(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "pregnancy",
        value: value,
      });
    },
    setChildren(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "children",
        value: value,
      });
    },
    setParents(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "parents",
        value: value,
      });
    },
    setHandicaps(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "handicaps",
        value: value,
      });
    },
  },
};
</script>

<style scoped>
.deduct_personal {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 34px;

  justify-content: space-between;
}

.dpb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 16px;
  max-width: 352px;
  text-align: left;
}

.dpb-answer {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: 352px;
}
.dpba-caption {
  display: flex;
}
.dpba-caption > span {
  color: #acb1bf;
  margin-left: 6px;
}
.left {
  text-align: left !important;
}
.dpba-input {
  height: 24px;
  width: 320px;
  padding: 15px 16px;
  border-radius: 5px;
  border: 1px solid #acb1bf;
}
.dpba-fixed {
  border: 1px solid #d8d9e0;
  pointer-events: none;
  cursor: default;
}

.dpb-footer {
  margin-top: 24px;
  margin-bottom: 31px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 352px;
}
.dpb-footer .crl-link {
  justify-content: flex-end;
}

.dp-loading {
  width: 100%;
  height: 8px;
  background: #e6e8ec;
  position: relative;
}
.dpl-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 25%;
  height: 100%;
  background: #008fc1;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .deduct_personal {
    padding-top: 50px;
  }

  .dpb-detail {
    max-width: 514px;
    text-align: center;
    white-space: nowrap;
    margin-bottom: 28px;
  }
}
</style>
